import React from 'react';

const useDisclosure = (defaultOpenStatus = false) => {
  const [isOpen, setIsOpen] = React.useState(defaultOpenStatus);

  const onClose = () => {
    setIsOpen(false);
  };

  const onOpen = () => {
    setIsOpen(true);
  };

  const onToggle = () => {
    setIsOpen(!isOpen);
  };

  return { isOpen, onClose, onOpen, onToggle };
};

export default useDisclosure;
